// extracted by mini-css-extract-plugin
export default {"reference_insured_grid_container":"AdminReferenceInsured_reference_insured_grid_container__5b+d2","description_container":"AdminReferenceInsured_description_container__iLjsd"};